import {
  CONFIGURATION,
  Sentry,
} from './initialize.js'
import _ from 'lodash'

// Log
const log = ( ...args ) => {
  let backgroundColor = '#718096'
  const borderRadius = '.1rem'
  const color = '#edf2f7'
  const display = 'inline-block'
  const padding = '.15rem .25rem'
  let style = `
      background-color: ${ backgroundColor };
      border-radius: ${ borderRadius };
      color: ${ color };
      display: ${ display };
      padding: ${ padding };
    `

  if ( args.length === 1 ) {
    console.groupCollapsed( `%c${ args[ 0 ] }`, style )
    console.groupCollapsed( 'Trace' )
    console.trace()
    console.groupEnd()
    console.groupEnd()
  } else {
    const module = args[ 0 ]
    const message = args[ 1 ]
    const sublogs = args[ 2 ]
    const type = args[ 3 ]

    if ( type === 'alert' ) {
      backgroundColor = '#c53030'
      style = `
        background-color: ${ backgroundColor };
        border-radius: ${ borderRadius };
        color: ${ color };
        display: ${ display };
        padding: ${ padding };
      `
    }

    if ( CONFIGURATION?.DEBUG[ module ] ) {
      console.groupCollapsed( `%c${ module } ${ message }`, style )
      if ( _.isArray( sublogs ) ) {
        _.each( sublogs, sublog => {
          console.log( '↳', sublog )
        } )
      } else {
        sublogs && console.log( '↳', sublogs )
      }
      console.groupCollapsed( 'Trace' )
      console.trace()
      console.groupEnd()
      console.groupEnd()
    }
  }
}

// Info
const info = ( ...args ) => {
  const style = `
      color: #718096;
      display: inline-block;
      padding: 0 .25rem;
    `

  if ( args.length === 1 ) {
    console.info( `%c${ args[ 0 ] }`, style )
  } else {
    const module = args[ 0 ]

    if ( CONFIGURATION?.DEBUG[ module ] ) {
      console.info( `%c${ args[ 0 ] }`, style )
    }
  }
}

// Warn
const warn = ( () => {
  return Function.prototype.bind.call( console.warn, console )
} )()

// Error
const error = ( () => {
  return Function.prototype.bind.call( console.error, console )
} )()

// Remote Error
const remoteError = ( module, message ) => {
  const _error = new Error()
  _error.name = module
  _error.message = message

  if ( CONFIGURATION?.SENTRY_DSN ) {
    Sentry.captureException( _error )
    warn( _error )
  } else {
    console.warn( 'Sentry has not been configured. Remote error follows.' )
    console.error( _error )
  }
}

// Remote Message
const remoteMessage = ( message ) => {
  if ( CONFIGURATION?.SENTRY_DSN ) {
    Sentry.captureMessage( message )
    info( message )
  } else {
    console.warn( 'Sentry has not been configured. Remote message follows.' )
    console.log( message )
  }
}

export {
  error,
  info,
  log,
  remoteError,
  remoteMessage,
  warn,
}
